module.exports = __webpack_public_path__ + "img/sign.8f7cad9d.png";